import * as ReactDOM from 'react-dom/client';
import { theme } from './theme';
import { CacheProvider } from '@emotion/react';
import createCache, { EmotionCache } from '@emotion/cache';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { App, AppProps } from './App';

// const isDev = process.env.NODE_ENV === 'development';

const customSheet = new CSSStyleSheet();
customSheet.replaceSync(`
 :host {
      display: flex;
      flex-grow: 1;
    }

`);
class Module extends HTMLElement {
  shadow: ShadowRoot;

  styleRoot: HTMLDivElement;

  root: HTMLDivElement;

  app: ReactDOM.Root;

  cache: EmotionCache;

  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });
    this.shadow.adoptedStyleSheets = [customSheet];
    this.styleRoot = document.createElement('div');
    this.root = document.createElement('div');
    this.styleRoot.dataset.style = '';
    this.root.dataset.app = '';
    this.root.style.flexGrow = '1';
    this.root.style.display = 'flex';
    this.app = ReactDOM.createRoot(this.root);
    this.cache = createCache({
      key: 'css',
      prepend: true,
      container: this.styleRoot,
    });
  }

  connectedCallback() {
    if (this.isConnected) {
      this.mount();
    }
  }

  disconnectedCallback() {
    if (!this.isConnected) {
      this.unmount();
    }
  }

  static get observedAttributes() {
    return [
      'module',
      'companyid',
      'companyaddressid',
      'baseroute',
      'updatelocation',
      'userid',
      'externalrouteselectionid',
    ];
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (oldValue !== newValue) {
      const keys = name.split('-');
      const key = (keys[0] + `${keys[1]?.charAt(0).toUpperCase()}${keys[1]?.slice(1)}` ||
        '' + keys[1]?.slice(1) ||
        '') as keyof AppProps;
      this.render({
        [key]: newValue,
        module: this.module,
        companyid: this.companyid,
        companyaddressid: this.companyaddressid,
        baseroute: this.baseroute,
        updatelocation: this.updatelocation,
        userid: this.userid,
        externalrouteselectionid: this.externalrouteselectionid,
      });
    }
  }

  get module() {
    return this.getAttribute('module');
  }

  get companyid() {
    return this.getAttribute('companyid');
  }

  get companyaddressid() {
    return this.getAttribute('companyaddressid');
  }

  get baseroute() {
    return this.getAttribute('baseroute');
  }

  get updatelocation() {
    return this.getAttribute('updatelocation');
  }

  get userid() {
    return this.getAttribute('userid');
  }

  get externalrouteselectionid() {
    return this.getAttribute('externalrouteselectionid');
  }

  render(props: AppProps) {
    return this.app.render(
      <CacheProvider value={this.cache}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App {...props} />
        </ThemeProvider>
      </CacheProvider>,
    );
  }

  mount() {
    this.shadow.append(this.styleRoot);
    this.shadow.append(this.root);
    this.render({
      module: /*  isDev ? 'LIS' : */ this.module,
      companyid: /*  isDev ? 'f378a4ba-b3a1-4e77-8d3b-f3beec60771a' : */ this.companyid, // Opening LIS selections in development mode
      companyaddressid: this.companyaddressid,
      baseroute: this.baseroute,
      updatelocation: this.updatelocation,
      userid: this.userid,
      externalrouteselectionid: this.externalrouteselectionid,
    });
  }

  unmount() {
    this.app.unmount();
    this.root.remove();
    this.styleRoot.remove();
  }
}

window.customElements.define('web-selections', Module);
